import { Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from '../../filtersSchema'
import { companyTypes } from './constants'

export const CompanyTypesFilter = () => {
  const { setValue, watch } = useFormContext<FiltersSchema>()

  const companyTypesValue = watch('company.companyTypes') ?? []

  const selectableColumnsCheckboxes = useMemo(() => {
    return companyTypes.map(({ id, label }) => {
      const isSelected = companyTypesValue.includes(id)
      return (
        <Field key={`statues-filter-${id}`}>
          <Checkbox
            value={isSelected}
            onChange={(checked) => {
              if (!checked) {
                setValue(
                  'company.companyTypes',
                  companyTypesValue.filter((status) => status !== id)
                )
              } else {
                setValue('company.companyTypes', [...companyTypesValue, id])
              }
            }}
          >
            <span>{label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [companyTypesValue])

  return selectableColumnsCheckboxes
}
